import React, { useState, useEffect } from 'react';
import { showTemporaryMessage } from "../components/Message";
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';

import PickUser from '../components/PickUser';
import UserDetails from '../components/UserDetails';
import EmergencyContacts from '../components/EmergencyContacts';

const Home = () => {
	const { userType, loginToken, userId } = React.useContext(AuthContext);
	const { t } = useTranslation();
	const [isEditingContacts, setIsEditingContacts] = useState(false);

	return (
		<div className="flex-grow w-full">
			{/* Heading */}
			<div className="super-admin w-full bg-light-blue shadow mb-10">
				<div className="max-w-screen-xl mx-auto py-4 px-4 text-center sm:text-start">
				<h1 className="text-4xl font-extrabold text-black">{t("page_home")}</h1>
				</div>
			</div>
			<div className="max-w-screen-xl mx-auto px-6">
				{/* Dashboard content */}
				<p className="text-base mb-6">{t("page_home_instructions")}</p>
				<div className="flex w-full gap-4 h-auto items-top justify-stretch flex-col lg:flex-row">
					<div className={`flex-1 ${isEditingContacts ? 'opacity-50 pointer-events-none' : ''}`}>
						<UserDetails
							loginToken={loginToken}
							loggedInUserId={userId}
							loggedInUserType={userType}
							selectedUserId={userId} />
					</div>
					<div className="flex-1">
						<EmergencyContacts 
							loginToken={loginToken} 
							isEditingContacts={isEditingContacts}
							setIsEditingContacts={setIsEditingContacts}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
